import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogleLogin } = useAuth();
  const processed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate('/'); return; }
    const sid = m[1];
    completeGoogleLogin(sid)
      .then((u) => {
        toast.success(`Welcome, ${u.name}! Your 1-day free trial has started — 3 scans on the house.`);
        window.history.replaceState(null, '', '/app');
        navigate('/app', { replace: true });
      })
      .catch((e) => { setErr(e.message || 'Auth failed'); });
  }, [location, navigate, completeGoogleLogin]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#fefdf9]">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-emerald-700 animate-spin mx-auto mb-3" />
        <p className="text-emerald-950/70">{err ? `Error: ${err}` : 'Signing you in…'}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
